<template>
  <div>
    <template v-if="scoreAuditResultList && scoreAuditResultList.length > 0">
      <div
        :class="item.scoreLevel === 'F' ? 'danger-color' : 'warn-color'"
        v-for="(item, index) in scoreAuditResultList" :key="index">
        <div>{{item.scoreResultText}}（{{item.acctId}}） {{formatDate(item.scoreTime) }}</div>
        <div v-if="item.onsite">Onsite: {{onsite[item.onsite]}}</div>
        <div v-if="item.remark">{{ t('dict.label.complianceRemark') }}: {{item.remark}}</div>
      </div>
    </template>
    <div class="warn-color" v-else>{{ t('dict.growKycScore.unrated') }}</div>
  </div>
</template>
<script>
// import mixins from '@/mixins'
import { dataUtils } from "@libs/utils";
import { useI18n } from "@/plugins/i18n";
import { onsite } from "@/domain/modules/client-options"

const { t } = useI18n()
export default {
  name: 'grow-kyc-audit-result',
  // mixins: [mixins.base],
  props: {
    scoreList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      onsite: onsite
    }
  },
  computed: {
    scoreAuditResultList() {
      console.log(this.scoreList, 'this.scoreList===')
      return this.getScoreResultInfo(this.scoreList)
    }
  },
  methods: {
    formatDate(VALUE) {
      dataUtils.formatDate(VALUE, "YYYY-MM-DD HH:mm")
    },
    t(value) {
      return t(value)
    },
    getScoreResultInfo(kycScoreViewList) {
      const scoreAuditResultList = [];
      if (kycScoreViewList && kycScoreViewList.length) {
        kycScoreViewList.forEach(item => {
          const scoreEntity = {
            acctId: item.acctId,
            score: item.kycScore && item.kycScore.length ? (item.kycScore[item.kycScore.length - 1]).score : null,
            scoreTime: item.kycScore && item.kycScore.length ? item.kycScore[item.kycScore.length - 1].scoreTime : null,
            remark: item.kycScore && item.kycScore.length ? item.kycScore[item.kycScore.length - 1].remark : null,
            onsite: item.onsite,
            scoreResultText: '',
            scoreLevel: null // 是否不合格
          };
          scoreEntity.scoreResultText = this.getScoreResultText(scoreEntity.score).text;
          scoreEntity.scoreLevel = this.getScoreResultText(scoreEntity.score).scoreLevel;
          scoreAuditResultList.push(scoreEntity);
        });
      }
      console.log('scoreAuditResultList', scoreAuditResultList);
      return scoreAuditResultList;
    },

    getScoreResultText(score) {
      if (score !== null && score >= 0 && score < 60) {
        return { text: t('dict.growKycScore.notPass'), scoreLevel: 'F' };
      } else if (score >= 60 && score < 80) {
        return { text: t('dict.growKycScore.pass'), scoreLevel: 'S' };
      } else if (score >= 80) {
        return { text: t('dict.growKycScore.excellent'), scoreLevel: 'S' };
      } else {
        return { text: t('dict.growKycScore.unrated'), scoreLevel: null };
      }
    },
  }
}
</script>

<style scoped>
.danger-color{
  color:#F56C6C;
}
.warn-color{
  color:#E6A23C;
}
</style>
